import { faAlignLeft } from '@fortawesome/pro-regular-svg-icons';
import React from 'react';
import { Resource } from '../../../../common/constants/resource';
import { TaskState } from '../../../../common/constants/states';
import { scrollToSection } from '../../../../common/utilities';
import { TaskTypes } from '../../../tasks/types/taskTypes';
import Completed from './Completed';
import Decision from './Decision';
import DoctorInfo from './DoctorInfo';
import Error from './Error';
import { handleClick } from './helper';
import NavLink from './NavLink';
import Notes from './Notes';
import Ordered from './Ordered';
import Overview from './Overview';
import PIA from './PIA';
import Requested from './Requested';
import Review from './Review';
import RuleResults from './RuleResults';
import * as styles from './styles.module.scss';
import Waived from './Waived';

function defaultTaskMappedIcon(
  copy: string,
  dataLinkId: any,
  isActive?: boolean,
  setActive?: (ev: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void,
) {
  const iconContainerClasses = `${styles.LeftNavIconLinkContainer} ${styles.IconLinkContainer}`;
  const config = {
    prefix: '',
    name: '',
    iconClass: styles.Icon,
    linkClass: styles.LinkRight,
    iconContainerClass: iconContainerClasses,
  };
  switch (copy.toUpperCase()) {
    case TaskTypes.DECISION:
      return (
        <Decision
          dataLinkId={dataLinkId}
          isActive={isActive}
          setActive={setActive}
        />
      );
    case TaskTypes.OVERVIEW:
      return (
        <Overview
          dataLinkId={dataLinkId}
          isActive={isActive}
          setActive={setActive}
        />
      );
    case TaskTypes.SUMMARY:
      return (
        <NavLink
          dataLinkId={dataLinkId}
          icon={faAlignLeft}
          iconClassName={`${styles.Icon} ${isActive ? styles.Active : ''}`}
          iconContainerClassName={`${styles.LeftNavIconLinkContainer} ${styles.IconLinkContainer}`}
          textClassName={`${styles.LinkRight} ${styles.NotesLink} ${
            isActive ? styles.Active : ''
          }`}
          copy="Summary"
          onClick={ev => handleClick(ev, setActive)}
        />
      );
    case TaskTypes.PIA:
      return (
        <PIA
          dataLinkId={dataLinkId}
          isActive={isActive}
          setActive={setActive}
        />
      );
    case Resource.DOCTOR_INFO_TITLE.toUpperCase():
      return (
        <DoctorInfo
          dataLinkId={dataLinkId}
          isActive={isActive}
          setActive={setActive}
        />
      );
    case TaskTypes.NOTES:
      return (
        <Notes
          dataLinkId={dataLinkId}
          isActive={isActive}
          setActive={setActive}
        />
      );
    case Resource.RULE_RESULTS_TITLE.toUpperCase():
      return (
        <RuleResults
          dataLinkId={dataLinkId}
          isActive={isActive}
          setActive={setActive}
        />
      );

    default:
      return (
        <NavLink
          dataLinkId={dataLinkId}
          iconClassName={config.iconClass}
          iconContainerClassName={config.iconContainerClass}
          textClassName={config.linkClass}
          copy={copy}
          onClick={scrollToSection}
        />
      );
  }
}

/**
 * The rest of the icons can be in any of the following states:
 * For Review, Required, Ordered, Waived, Completed, Error
 */
const renderMappedIconLink = (
  state: string,
  linkCopy: string,
  dataLinkId: any,
  isActive?: boolean,
  setActive?: (ev: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void,
) => {
  switch (state) {
    case TaskState.FOR_REVIEW:
      return (
        <Review
          dataLinkId={dataLinkId}
          copy={linkCopy}
          isActive={isActive}
          setActive={setActive}
        />
      );
    case TaskState.COMPLETED:
      return (
        <Completed
          dataLinkId={dataLinkId}
          copy={linkCopy}
          isActive={isActive}
          setActive={setActive}
        />
      );
    case TaskState.ERROR:
      return (
        <Error
          dataLinkId={dataLinkId}
          copy={linkCopy}
          isActive={isActive}
          setActive={setActive}
        />
      );
    case TaskState.ORDERED:
      return (
        <Ordered
          dataLinkId={dataLinkId}
          copy={linkCopy}
          isActive={isActive}
          setActive={setActive}
        />
      );
    case TaskState.WAIVED:
      return (
        <Waived
          dataLinkId={dataLinkId}
          copy={linkCopy}
          isActive={isActive}
          setActive={setActive}
        />
      );
    case TaskState.REQUESTED:
      return (
        <Requested
          dataLinkId={dataLinkId}
          copy={linkCopy}
          isActive={isActive}
          setActive={setActive}
        />
      );
    case TaskState.DEFAULT:
    default:
      return defaultTaskMappedIcon(linkCopy, dataLinkId, isActive, setActive);
  }
};

const IconMapper = ({
  state,
  copy,
  isActive,
  setActive,
  dataLinkId,
}: {
  state: string;
  copy: string;
  dataLinkId: string;
  isActive?: boolean;
  setActive?: (ev: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
}) => {
  return renderMappedIconLink(state, copy, dataLinkId, isActive, setActive);
};

export default IconMapper;
